import React from 'react'
import RequestPermissionsContainer from './request-permissons-container'

export const RequestPermissions = () => (
    <RequestPermissionsContainer>
        {() => (<p>Carregando...</p>)}
    </RequestPermissionsContainer>
)

                